import { URLSearchParams, BaseRequestOptions } from '@angular/http';

export const createRequestOption = (request?: any): BaseRequestOptions => {
    const options: BaseRequestOptions = new BaseRequestOptions();
    if (request) {
        const params: URLSearchParams = new URLSearchParams();
        params.set('page', request.page);
        params.set('size', request.size);
        if (request.sort) {
            params.paramsMap.set('sort', request.sort);
        }
        params.set('query', request.query);

        options.params = params;
    }
    return options;
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/request-utils.ts